import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import MapPage from "./pages/Map";
import BranchDetail from "./pages/BranchDetail";
import Careers from "./pages/Careers";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import { getSettings } from "./api/client";
import Preloader from "./components/Preloader";


// Import AOS (Animate On Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
    // Lifted state for global settings, language, and theme
    const [settings, setSettings] = useState({ en: {}, ar: {} });
    const [lang, setLang] = useState(localStorage.getItem('ib_lang') || "en");
    const [theme, setTheme] = useState(localStorage.getItem('ib_theme') || "light");

    const [showPreloader, setShowPreloader] = useState(true);

    useEffect(() => {
        // Preloader Logic
        document.body.style.overflow = 'hidden'; // Lock scroll

        const timer = setTimeout(() => {
            setShowPreloader(false);
            document.body.style.overflow = 'auto'; // Unlock scroll
        }, 2500); // 2.5 seconds

        return () => {
            clearTimeout(timer);
            document.body.style.overflow = 'auto'; // Cleanup
        };
    }, []);

    useEffect(() => {
        // Initialize AOS
        if (!showPreloader) {
            AOS.init({
                duration: 800,
                easing: 'slide',
                once: true
            });
        }

        // Theme Effect
        if (theme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
        localStorage.setItem('ib_theme', theme);

        // Lang Effect
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        localStorage.setItem('ib_lang', lang);

        // Fetch settings
        const fetchSettings = async () => {
            try {
                const response = await getSettings();
                if (response.data) {
                    setSettings({
                        en: response.data.static_en || {},
                        ar: response.data.static_ar || {}
                    });
                }
            } catch (error) {
                console.error("Failed to fetch settings:", error);
            }
        };
        fetchSettings();
    }, [lang, theme, showPreloader]);

    return (
        <Router>
            <Layout settings={settings} lang={lang} setLang={setLang} theme={theme} setTheme={setTheme}>
                <Routes>
                    <Route path="/" element={<Home settings={settings} lang={lang} theme={theme} />} />
                    <Route path="/about" element={<About settings={settings} lang={lang} />} />
                    <Route path="/services" element={<Services settings={settings} lang={lang} />} />
                    <Route path="/service/:slug" element={<ServiceDetail settings={settings} lang={lang} />} />
                    <Route path="/projects" element={<Projects settings={settings} lang={lang} />} />
                    <Route path="/project/:slug" element={<ProjectDetail settings={settings} lang={lang} />} />
                    <Route path="/map" element={<MapPage settings={settings} lang={lang} />} />
                    <Route path="/branch/:slug" element={<BranchDetail settings={settings} lang={lang} />} />
                    <Route path="/careers" element={<Careers settings={settings} lang={lang} />} />
                    <Route path="/blog" element={<Blogs settings={settings} lang={lang} />} />
                    <Route path="/blog/:slug" element={<BlogDetail settings={settings} lang={lang} />} />
                    <Route path="/contact" element={<Contact settings={settings} lang={lang} />} />
                    {/* Fallback route */}
                    <Route path="*" element={<Home settings={settings} lang={lang} />} />
                </Routes >
            </Layout >
            {showPreloader && <Preloader />
            }
        </Router >
    );
}

export default App;
